module.exports = __webpack_public_path__ + "img/icon-progress-red.3ecae10d.png";